import { Navigate } from 'react-router-dom'
import { useSession } from '../lib/sessionContext'
import { ROLES, TENANT_MANAGER_ROLES } from './navigation'

/** Keeps the tenant dashboard distinct from the CoEIA/platform operator surface. */
export default function TenantDashboardGate({ children }) {
  const { session } = useSession()
  const roles = session?.roles ?? []

  if (roles.includes(ROLES.SystemManagers)) {
    return <Navigate to="/companies" replace />
  }

  if (!TENANT_MANAGER_ROLES.some((role) => roles.includes(role))) {
    return <Navigate to="/unauthorized" replace />
  }

  return children
}
